import { useMutation, useQueryClient } from 'react-query';
import { post } from 'Core/utils/platformApi';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import useAlertStore, { setErrorAlertSelector } from 'Core/stores/alert';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-location';
import { applicationNotFoundPath } from 'Modules/easyCredit/routes';

function transformPayload({ acceptedTerms }) {
  return {
    provided_at: new Date().toISOString(),
    data_processing: true,
    ip_address: '127.0.0.1',
    accepted_terms_and_condition: acceptedTerms,
  };
}

export default function useSubmitConsent() {
  const { t } = useTranslation();
  const setErrorAlert = useAlertStore(setErrorAlertSelector);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    ({ customerGid, externalReferenceId, acceptedTerms }) => {
      const requestId = uuidv4();

      return post(
        '/financing/purchase/consent',
        transformPayload({ acceptedTerms }),
        {
          headers: {
            request_id: requestId,
            customer_gid: customerGid,
            external_reference_id: externalReferenceId,
          },
        }
      ).then((data) => ({ ...data, requestId }));
    },
    {
      onSuccess() {
        queryClient.invalidateQueries(cacheKeys.easyCreditLatestRequest);
      },
      onError(error) {
        setErrorAlert(
          error?.response?.data?.message || error.message
        );
        navigate({ to: applicationNotFoundPath, search: true, replace: false });
      },
    }
  );
}

